import React, {useEffect} from 'react';
import {
  Switch,
  Route,
  Redirect,
  match,
} from 'react-router-dom';
import {connect} from 'react-redux';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import {AppState} from './Store';
import {loadVersionsCreator} from './Store/Tickets/Actions';

import Development from './Tickets/Development';

type TParams = {
};

interface TicketsProps {
  match: match<TParams>;

  authorised: boolean;
  loadVersions: () => Promise<void>;
}

function Tickets({
  match: {path},
  loadVersions,
  authorised,
}: TicketsProps) {
  useEffect(() => {
    if (!authorised) {
      return;
    }
    loadVersions();
  }, [authorised, loadVersions]);

  return (
    <div className="main-content-wrapper section-padding-100">
      <div className="container">
        <Switch>
          <Route path={`${path}/development`} component={Development} />
          <Redirect to={`${path}/development`} />
        </Switch>
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    authorised: state.auth.authorised,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    loadVersions: () => dispatch(loadVersionsCreator()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
